import React from "react";
import { motion } from "framer-motion";
import { Car, Truck, HardHat, ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";

export const Sectors = () => {
  const { t } = useLang();
  const items = [
    { icon: Car, key: "auto", img: "https://images.unsplash.com/photo-1758322680193-56fe2af8fd59?crop=entropy&cs=srgb&fm=jpg&q=80&w=800" },
    { icon: Truck, key: "truck", img: "https://images.unsplash.com/photo-1695222833131-54ee679ae8e5?crop=entropy&cs=srgb&fm=jpg&q=80&w=800" },
    { icon: HardHat, key: "civil", img: "https://images.unsplash.com/photo-1503708928676-1cb796a0891e?crop=entropy&cs=srgb&fm=jpg&q=80&w=800" },
  ];
  return (
    <section id="services" className="relative py-24 sm:py-32 max-w-7xl mx-auto px-5 sm:px-8" data-testid="sectors">
      <div className="mb-14 max-w-2xl">
        <p className="text-xs uppercase tracking-[0.2em] text-accent mb-3">I-LEASE SRL</p>
        <h2 className="font-display text-3xl sm:text-5xl font-bold">{t.sectors.title}</h2>
        <p className="mt-4 text-muted-foreground text-lg">{t.sectors.subtitle}</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {items.map(({ icon: Icon, key, img }, i) => (
          <motion.div key={key}
            initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.12 }}
            className="group relative rounded-2xl overflow-hidden border border-white/10 bg-card hover:-translate-y-1.5 transition-transform duration-300"
            data-testid={`sector-${key}`}>
            <div className="relative h-52 overflow-hidden">
              <img src={img} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-card via-card/40 to-transparent" />
              <div className="absolute top-4 left-4 w-11 h-11 rounded-xl glass flex items-center justify-center">
                <Icon className="w-5 h-5 text-accent" strokeWidth={1.5} />
              </div>
            </div>
            <div className="p-6">
              <div className="flex items-center justify-between">
                <h3 className="font-display text-xl font-bold">{t.sectors[key].t}</h3>
                <ArrowUpRight className="w-5 h-5 text-muted-foreground group-hover:text-accent group-hover:rotate-45 transition-all duration-300" strokeWidth={1.5} />
              </div>
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{t.sectors[key].d}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
